export default __webpack_public_path__ + "static/media/warning.1f0dd91c.svg";